import { type ReactNode, type PropsWithChildren } from "react";

interface ListProps extends PropsWithChildren {
  className?: string;
}

interface ListItemProps {
  label: string | ReactNode;
  value: string | number | ReactNode | null;
  strong?: boolean;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
}

const List = ({ children, className = "" }: ListProps) => {
  return <ul className={`flex flex-col ${className}`}>{children}</ul>;
};

const ListItem = ({ label, value, strong, className = "", labelClassName = "", valueClassName = "" }: ListItemProps) => {
  return (
    <li className={`flex items-center py-4 border-b border-gray-200 text-sm ${className}`}>
      <span className={`basis-1/2 flex-grow pr-2 font-semibold ${labelClassName}`}>{label}</span>
      <span className={`basis-1/2 flex-grow ${strong ? "text-base font-semibold" : "text-body"} ${valueClassName}`}>{value ?? "-"}</span>
    </li>
  );
};

const ColumnWrapper = ({ children }: React.PropsWithChildren) => {
  return <div className="flex items-center py-4 border-b border-gray-200">{children}</div>;
};

const ListColumnItem = ({ label, value, className = "", labelClassName = "", valueClassName = "" }: ListItemProps) => {
  return (
    <li className={`flex-1 flex flex-col gap-y-1 text-sm ${className}`}>
      <span className={`font-semibold ${labelClassName}`}>{label}</span>
      <span className={`text-body ${valueClassName}`}>{value ?? "-"}</span>
    </li>
  );
};

List.Item = ListItem;
List.ColumnWrapper = ColumnWrapper;
List.ColumnItem = ListColumnItem;

export default List;
